import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'
import { GET_CLIENTS } from '../../../../queries/index'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'

export default function Clients (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringFiltersContext)
  const { loading, error, data } = useQuery(GET_CLIENTS)

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { clients: tempClients } = data.ordersAggs.aggregations
  const clients: Array<string> = []

  tempClients.buckets.map((client: any) => {
    clients.push(client.key)
  })

  const onChange = (value: any) => {
    setFilters({
      clients: value
    })
  }

  const typographLabel = 'Clients'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={clients}
        defaultValues={filters.clients}
        onChange={onChange}
      />
    </Fragment>
  )
}
